<template>
  <a :href="termsOfUseUrl" rel="noopener noreferrer" target="_blank">Legal</a>
</template>

<script>
import AppConfig from '@/config';

export default {
  name: 'AppLegalInfoLink',
  data() {
    return {
      termsOfUseUrl: AppConfig.get('marketingSite').termsOfUseUrl,
    };
  },
};
</script>
